import { createFileRoute, Link } from "@tanstack/react-router";

import { LegalPage, LegalSection } from "../components/legal-page";
import { seo } from "../lib/head";
import { LEGAL } from "../lib/legal";

export const Route = createFileRoute("/mentions-legales")({
  staticData: { ssr: true },
  head: () =>
    seo({
      title: "Mentions légales · Listou",
      description: "Éditeur, hébergement et contact du site Listou.",
    }),
  component: LegalNoticePage,
});

function LegalNoticePage() {
  const { publisher, host } = LEGAL;
  return (
    <LegalPage title="Mentions légales">
      <LegalSection title="Éditeur">
        <p>
          {`Le site Listou est édité par ${publisher.name}, ${publisher.status} (${publisher.registration}).`}
        </p>
        <p>
          Contact : <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>
        </p>
        <p>Directeur de la publication : {publisher.director}.</p>
      </LegalSection>

      <LegalSection title="Hébergement">
        <p>
          Le site est hébergé par {host.name}, {host.address}, {host.phone}.
        </p>
        <p>
          Le trafic transite par Cloudflare, Inc., 101 Townsend St, San Francisco, CA 94107,
          États-Unis. La base de données est hébergée par PlanetScale, Inc. et les emails sont
          envoyés par Amazon Web Services (Amazon SES).
        </p>
      </LegalSection>

      <LegalSection title="Liens affiliés">
        <p>
          Certains liens vers des boutiques sont des liens affiliés : si vous achetez après avoir
          cliqué, Listou peut percevoir une commission, sans surcoût pour vous. En tant que
          Partenaire Amazon, Listou réalise un bénéfice sur les achats remplissant les conditions
          requises.
        </p>
        <p>
          Les prix affichés sont indicatifs et relevés à un instant donné. Seul le prix affiché par
          la boutique au moment de l'achat fait foi.
        </p>
      </LegalSection>

      <LegalSection title="Contenus publiés par les utilisateurs">
        <p>
          Les listes, souhaits et avis sont rédigés par leurs auteurs, qui en sont responsables.
          Pour signaler un contenu illicite, écrivez à{" "}
          <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a> en indiquant l'adresse
          de la page concernée. Les avis peuvent aussi être signalés directement depuis la page du
          produit.
        </p>
      </LegalSection>

      <LegalSection title="Propriété intellectuelle">
        <p>
          La marque Listou, le site, ses textes, illustrations et autocollants sont protégés. Toute
          reproduction sans autorisation est interdite. Les noms et images de produits appartiennent
          à leurs titulaires respectifs.
        </p>
      </LegalSection>

      <LegalSection title="Données personnelles">
        <p>
          Le traitement de vos données est décrit dans la{" "}
          <Link to="/confidentialite">politique de confidentialité</Link>.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
